import React, {Component} from 'react';
import validate from './validation';
import {Chip, Grid, Typography} from 'material-ui';
import {Field, reduxForm} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {InputHiddenField} from '../../../components/fields/field_input_hidden';
import {SimpleEditorField} from '../../../components/fields/field_simple_editor';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';
import {removeBlankParagraphs} from '../../../components/helpers/helpers';
import PagePicker from '../../page-picker/page_picker';
import {BLOCK_TYPE_ACCREDITATION_ID} from '../types';

class BlockTranslationNewForm extends Component {
    isBlockTypeAccrediation = () => {
        return this.props.block.block_type_id === BLOCK_TYPE_ACCREDITATION_ID;
    };

    render() {
        const {
            blockSiteTranslation,
            block,
            pagePickerPopupOpen,
            togglePagePickerPopup,
            pageSearchCriteria,
            getAllReviewPages,
            pagePickerPage,
            classes,
            handleSubmit,
            pristine,
            touched,
            loading,
        } = this.props;

        let pagePickerPageTitle = 'None Selected';
        if (pagePickerPage && typeof pagePickerPage.title !== 'undefined') {
            pagePickerPageTitle = pagePickerPage.title;
        }

        return (
            <Grid container>
                <Grid item xs={12} md={6}>
                    <div className="heading">
                        <p className="lead">
                            Initial content for Block:{' '}
                            <em>"{block.display_name}"</em>
                        </p>
                    </div>
                    <Field
                        className={classes.inputFormField}
                        name="initialName"
                        component={InputTextField}
                        label={block.display_name}
                        fullWidth
                        disabled
                    />
                    <Field
                        className={classes.inputFormField}
                        name="initialTitle"
                        component={InputTextField}
                        label={block.title}
                        fullWidth
                        disabled
                    />
                    {this.isBlockTypeAccrediation() && (
                        <Field
                            className={classes.inputFormField}
                            name="initialButtonText"
                            component={InputTextField}
                            label={block.button_text}
                            fullWidth
                            disabled
                        />
                    )}
                    <Typography
                        variant="body2"
                        style={{color: '#a5a5a5', marginTop: 20}}
                        dangerouslySetInnerHTML={{
                            __html: removeBlankParagraphs(block.body),
                        }}
                        className="pbSectionEditorText"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <div className="heading">
                        <p className="lead">
                            Translation for {blockSiteTranslation.site_name}
                        </p>
                    </div>
                    <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Field
                                    name="id"
                                    type="hidden"
                                    component={InputHiddenField}
                                />
                                <Field
                                    name="block_id"
                                    type="hidden"
                                    component={InputHiddenField}
                                />
                                <Field
                                    name="display_name"
                                    component={InputTextField}
                                    label="Translated Name"
                                    fullWidth
                                    InputLabelProps={{
                                        required: true,
                                    }}
                                />
                                <Field
                                    name="title"
                                    component={InputTextField}
                                    label="Translated Title"
                                    fullWidth
                                />
                                {this.isBlockTypeAccrediation() && (
                                    <Field
                                        name="button_text"
                                        component={InputTextField}
                                        label="Translated Button Text"
                                        fullWidth
                                    />
                                )}
                                {this.isBlockTypeAccrediation() && (
                                    <React.Fragment>
                                        <br />
                                        <Chip
                                            className={
                                                classes.sectionLinkToPageChip
                                            }
                                            label={
                                                'Read more Page Link *: ' +
                                                pagePickerPageTitle
                                            }
                                            onClick={togglePagePickerPopup}
                                        />
                                        <br />
                                    </React.Fragment>
                                )}
                                <br />
                                <br />
                                <Field
                                    name="body"
                                    component={SimpleEditorField}
                                    label="Translated Body"
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                <SaveButton
                                    type="submit"
                                    loading={loading}
                                    disabled={(!touched && pristine) || loading}
                                    variant="raised"
                                    color="primary"
                                    className="floatRight"
                                />
                                <BackButton
                                    link={
                                        '/blocks/' + block.id + '/translations'
                                    }
                                    style={{marginRight: 15}}
                                    variant="raised"
                                    className="floatRight"
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <PagePicker
                                open={pagePickerPopupOpen}
                                handleClose={togglePagePickerPopup}
                                allPagesBySearchCriteria={
                                    this.props.allPagesBySearchCriteria
                                }
                                searchString={pageSearchCriteria}
                                onPick={(pageId, pageTitle) => {
                                    this.props.onPickBlockPage(
                                        pageId,
                                        pageTitle
                                    );
                                    togglePagePickerPopup();
                                }}
                                onSearchPages={(event) => {
                                    this.props.onSearchPages(
                                        event.target.value,
                                        this.props.siteId,
                                        getAllReviewPages
                                    );
                                }}
                            />
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        );
    }
}

export default reduxForm({
    form: 'BlockTranslationNewForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
    validate,
})(BlockTranslationNewForm);



// WEBPACK FOOTER //
// ./src/containers/blocks/forms/CreateTranslationForm.jsx